"use client";

import { Atom, Beaker, Box, Cpu, Droplet, Flame, Layers, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Datacollectionnotice() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const materials = [{
    name: "Final Expense",
    description: "Simple, affordable coverage designed to handle funeral costs and final medical bills for your loved ones.",
    tensile: "Fixed",
    temp: "Lifetime",
    Icon: Layers
  }, {
    name: "Term Life",
    description: "Budget-friendly protection for a specific period, ensuring your family is secure during your working years.",
    tensile: "Flexible",
    temp: "10-30 Yrs",
    Icon: Droplet
  }, {
    name: "Whole Life",
    description: "Permanent coverage that builds cash value over time, providing a legacy for your beneficiaries.",
    tensile: "Guaranteed",
    temp: "Lifetime",
    Icon: Beaker
  }, {
    name: "Universal Life",
    description: "Adjustable premiums and death benefits that adapt to your changing financial needs throughout life.",
    tensile: "Adaptable",
    temp: "Lifetime",
    Icon: Box
  }, {
    name: "Accidental Death",
    description: "Targeted coverage for unexpected accidents, providing extra security when you need it most.",
    tensile: "Immediate",
    temp: "Renewable",
    Icon: Atom
  }, {
    name: "Guaranteed Issue",
    description: "No medical exams required, ensuring you can get coverage regardless of your health history.",
    tensile: "Simplified",
    temp: "Lifetime",
    Icon: Shield
  }, {
    name: "Mortgage Protection",
    description: "Specifically designed to pay off your home loan if you pass away, keeping your family in their house.",
    tensile: "Secured",
    temp: "Term-based",
    Icon: Cpu
  }, {
    name: "Living Benefits",
    description: "Access your death benefit early if you are diagnosed with a chronic or terminal illness.",
    tensile: "Accessible",
    temp: "Lifetime",
    Icon: Flame
  }];
  return <section data-section-id="2254" id="datacollectionnotice" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-6">
            <p className="font-default text-xs md:text-sm tracking-[0.2em] uppercase mb-6" style={{
            color: "var(--primary)"
          }}>
              Our Coverage Options
            </p>
            <h2 className="font-default font-bold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-foreground">
              Protect Your Family From Funeral Costs.
            </h2>
          </div>
          <div className="md:col-span-6 md:pt-4">
            <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl">
              Family Legacy Planning provides comprehensive insurance solutions to ensure your 
              loved ones are never burdened by unexpected final expenses. Secure your peace 
              of mind with our tailored protection plans.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {materials.map((material, i) => {
          const Icon = material.Icon;
          return <div data-index={i} key={material.name} className="group relative rounded-lg border border-border bg-card p-7 md:p-8 transition-all duration-300 ease-out hover:-translate-y-1 shadow-md hover:shadow-lg" style={{
            backgroundColor: "var(--card)"
          }}>
                {}
                <div className="mb-7 inline-flex h-[60px] w-[60px] items-center justify-center rounded-lg transition-colors duration-300" style={{
              backgroundColor: "var(--muted)"
            }}>
                  <Icon className="h-6 w-6 transition-colors duration-300 group-hover:text-white" strokeWidth={1.25} style={{
                color: "var(--primary)"
              }} />
                </div>

                {}
                <h3 className="font-default font-semibold text-[28px] leading-tight text-card-foreground mb-3">
                  {material.name}
                </h3>

                {}
                <p className="text-sm leading-relaxed text-muted-foreground mb-8">
                  {material.description}
                </p>

                {}
                <div className="pt-5 border-t border-border">
                  <p className="font-default text-xs tracking-wider uppercase" style={{
                color: "var(--muted-foreground)"
              }}>
                    <span style={{
                  color: "var(--primary)"
                }}>TYPE:</span>{" "}
                    <span className="text-foreground">{material.tensile}</span>
                    <span className="mx-2 opacity-50">·</span>
                    <span style={{
                  color: "var(--primary)"
                }}>TERM:</span>{" "}
                    <span className="text-foreground">{material.temp}</span>
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}